import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from '@material-ui/core/styles';
import { Alert} from '@material-ui/lab';
import UserContext from "../tools/UserContext";
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

import { useTranslation } from 'react-i18next';
   
const UiAlert = (props) => {

    const useStyles = makeStyles((theme) => ({
        root: {
            width: '100%',
            '& > * + *': {
                marginTop: theme.spacing(2),
            },
        },
    }));
    
    const classes = useStyles();
    const[open, setOpen] = React.useState(true);

    //const alertSeverity = "error";
    const alertSeverityArr = ["error", "warning", "info", "success"];

    const { t } = useTranslation();

    const { alertSeverity, alertMessage, handleMessage } = props;
    
    //const alertMessage = t('Message text goes here (Error, warning, info, success)') ; 
    
 
        
        return (
            <UserContext.Consumer>
                {
                    () => (
                        alertMessage !=="" ?
                        <div className={classes.root}>

                            <Collapse in={open}>
                                <Alert
                                        action={
                                            <IconButton
                                                aria-label="close"
                                                color="inherit"
                                                size="small"
                                                onClick={() => {
                                                    setOpen(false);
                                                    handleMessage("");
                                                }}
                                            >
                                                <CloseIcon fontSize="inherit" />
                                            </IconButton>
                                        }
                                        variant="outlined"
                                        severity={alertSeverity}
                                >
                                    <p className="alert-message"> {t(alertMessage)} </p>
                                </Alert>
                            </Collapse>

                            </div>
                            : ""

                    )}
            </UserContext.Consumer>
        );
    
}

UiAlert.propTypes = {
    alertSeverity: PropTypes.string.isRequired,
    alertMessage: PropTypes.string.isRequired,
    handleMessage: PropTypes.func.isRequired,

};

export default UiAlert;